class SurveyRangeControl {
    constructor(wrapper) {
        this.readDefaultData = () => {
            if (this.companionInput && this.rangeStates) {
                //we find any current answer
                let currentAnswer = this.companionInput.value || 'Neutral';
                // then we set the slider to be the index of the current answer
                this.rangeInput.value = this.rangeStates.indexOf(currentAnswer).toString();
                // trigger event
                this.rangeInput.dispatchEvent(new Event('input'));
            }
        };
        this.getRangeStates = () => {
            if (this.rangeInput.hasAttribute('data-range-states')) {
                this.rangeStates = this.rangeInput.getAttribute('data-range-states').split(',').map(item => item.replace(new RegExp("'", "g"), ""));
            }
        };
        this.rangeUpdateHandler = (e) => {
            if (this.rangeStates) {
                // update text for range value
                if (this.rangeLabel) {
                    this.rangeLabel.innerHTML = this.rangeStates[parseInt(this.rangeInput.value)];
                }
                // set companion value
                if (this.companionInput) {
                    this.companionInput.value = this.rangeStates[parseInt(this.rangeInput.value)];
                }
            }
        };
        this.init = () => {
            // register event
            // update label on range update
            this.rangeInput.addEventListener("input", this.rangeUpdateHandler);
            this.rangeInput.addEventListener("change", this.rangeUpdateHandler);
            // get range states
            this.getRangeStates();
            // read default value from server
            this.readDefaultData();
        };
        this.wrapper = wrapper;
        if (wrapper) {
            this.rangeInput = wrapper.querySelector('.survey-range-control-input');
            let companionElementId = this.rangeInput.getAttribute('data-companion-element');
            this.companionInput = document.getElementById(companionElementId);
            this.rangeLabel = wrapper.querySelector('.survey-range-control-value');
        }
    }
}
// initiate all survey-range fields
[].slice.call(document.querySelectorAll('.survey-range')).forEach(element => {
    new SurveyRangeControl(element).init();
});
export default undefined;
